import { Accordion, Item as AccordionItem } from 'devextreme-react/accordion'
import { Todo } from '@microsoft/mgt-react'

const ReminderCard = () => {
  return (
    <>
      <Accordion
        onSelectionChanged={(e) => {
          e.component?.repaint()
        }}
      >
        <AccordionItem title={'ToDo'} visible={true} icon="checklist">
          <Todo
            taskFilter={(task) => {
              return task.status !== 'completed'
            }}
          />
        </AccordionItem>
        <AccordionItem title={'Completati'} icon={'check'}>
          <Todo
            taskFilter={(task) => {
              return task.status === 'completed'
            }}
          />
        </AccordionItem>
      </Accordion>
    </>
  )
}

export default ReminderCard
